<template>
    <div class="order">
        <div class="order-list">
            <div class="order-search">
                <div class="title">我的返修</div>
                <div class="search-box">
                    <input placeholder="输入订单号搜索" v-model="keyword"/>
                    <div class="search" @click="search">搜索</div>
                </div>
            </div>
            <div class="order-tab">
                <Tabs :tabs="tabs" :cur="curIndex" @changeTab="changeTab"></Tabs>
            </div>
            <div class="orders" v-if="orderList.length > 0">
                <RefundItem v-for="(item,index) in orderList" :item="item" :key="index"
                           v-on:refresh="refresh"></RefundItem>
            </div>
            <div v-else>
                <NoOrder></NoOrder>
            </div>
            <Page :current="page" :total="total" :page-size="size" @on-change="changePage" show-total
                  style="margin-top: 20px;" show-sizer @on-page-size-change="changeSize"
                  :page-size-opts="[5, 10, 20]"></Page>
        </div>
    </div>

</template>

<script>
    import Tabs from "@/components/Tabs.vue";
    import RefundItem from "@/components/RefundItem.vue";
    import NoOrder from "@/components/NoOrder.vue";

    import {GetRefundList} from "@/api"

    export default {
        name: 'FixingList',
        components: {
            Tabs,
			RefundItem,
            NoOrder,

        },
        data() {
            return {
                page: 1,
                total: -1,
                size: 5,
                orderList: [],
                tabs: [
					{
						index: 0,
						title: '全部',
						value: 'all'
					},
                    {
                        index: 1,
                        title: '待审核',
                        value: 'create'
                    },
                    {
                        index: 2,
                        title: '待客户寄回',
                        value: 'waiting_customer'
                    },
                    {
                        index: 3,
                        title: '处理中',
                        value: 'fixing'
                    },
					{
						index: 4,
						title: '待客户收货',
						value: 'waiting_confirm'
					},
					{
						index: 5,
						title: '返修完成',
						value: 'complete'
					}
                ],
                curIndex: 0,
                orderStatus: "all",
                keyword: ''

            };
        },
        created() {
            this.getList()
        },
        methods: {
            refresh() {
                this.getList()
            },
            changeTab(index) {
                this.page = 1
                this.curIndex = index
                this.orderStatus = this.tabs[index].value
                this.getList()
            },
            changePage(page) {
                this.page = page
                this.getList()
            },
            changeSize(size) {
                this.page = 1
                this.size = size
                this.getList()
            },
            async getList() {
                let json = await GetRefundList({
                    page: this.page,
                    size: this.size,
                    status: this.orderStatus,
                    keyword: this.keyword
                })
                this.orderList = json.data.list
                this.total = json.data.count
            },
            search() {
                this.getList()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .order-list {
        background: #FFFFFF;
        padding-bottom: 10px;

        .order-search {
            height: 54px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;

            .title {
                font-size: 17px;
                color: #0F114A;
                font-weight: bold;
            }

            .search-box {
                width: 300px;
                height: 34px;
                border: 1px solid #B3B3B3;
                display: flex;
                align-items: center;

                input {
                    width: 240px;
                    height: 30px;
                    border: none;
                    padding-left: 10px;

                }

                .search {
                    border-left: 1px solid #B3B3B3;
                    width: 60px;
                    line-height: 34px;
                    height: 34px;
                    font-size: 15px;
                    font-weight: 400;
                    color: #676767;
                    text-align: center;
                    cursor: pointer;
                }
            }
        }

        .orders {
            margin-top: 20px;
            width: 100%;
            padding: 0 20px;
        }
    }

    .order-tab {
        padding: 0 20px;
    }


</style>
